import { bootstrapApplication } from '@angular/platform-browser';
import { PartnerWebAppComponent } from 'libs/partner-web-platform/src/lib/app/app.component';
import { appConfig } from './app/app.config';

bootstrapApplication(PartnerWebAppComponent, appConfig).catch((err) => console.error(err));
